import React, { Component } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import TreeNode from "./components/TreeNode";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <TreeNode />,
    },
    {
      path: "node/:id/:depth/:pathmax",
      element: <TreeNode />,
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  }
);

class App extends Component {
  render() {
    return (
      <React.StrictMode>
        <RouterProvider
          router={router}
          future={{
            v7_startTransition: true,
          }}
        />
      </React.StrictMode>
    );
  }
}

export default App;
